import { PerformanceModel } from '../../../models';
import { RootState } from '../../store';
import createEntityEditSlice, { EntityEditState, createIsPendingChangesSelector } from './createEntityEditSlice';

const slice = createEntityEditSlice({
    name: 'contractEditPerformance',
    initialState: { isEditing: false } as EntityEditState<PerformanceModel>,
    reducers: {},
});

const selectState = (state: RootState) => state.contractEditPerformance;
const selectIsPendingChanges = () => createIsPendingChangesSelector(selectState);

const contractEditPerformanceActions = { ...slice.actions };
const contractEditPerformanceSelectors = { selectIsPendingChanges };

export { contractEditPerformanceActions, contractEditPerformanceSelectors };
export default slice.reducer;
